import React from 'react';
import { observer } from 'mobx-react-lite';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Attractions from './pages/Attractions';
import UnderConstruction from './pages/UnderConstruction';

const App = observer(() => {
  
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/under-construction" element={<UnderConstruction />} />
          <Route path="/attractions" element={<Attractions/>} />
          <Route path="*" element={<Navigate to="/attractions" />} />
        </Routes>
      </div>
    </Router>
  );
});

export default App;
